import fields from './fields'

const AuthFormRules = {
  [fields.LOGIN]: 'required|min:6',
  [fields.PASSWORD]: 'required|min:10',
}

export default AuthFormRules
